import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee_migration",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Certification Bill Claim")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_migration",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Trainning Partner", -1)
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim No", -1)
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Bill", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "col-md-2 mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-4" }, "Select Batches for certification Bill Claim", -1)
const _hoisted_22 = { class: "card mb-5 mb-xl-10" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_24 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = { class: "card-body border-top p-6" }
const _hoisted_27 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-eye" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Partner",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAllBillNo()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: data.id,
                            label: data.entity_short_name,
                            value: data.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      name: "name",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.claim_no) = $event)),
                      class: "form-control",
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.batch.claim_no]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Bill",
                      modelValue: _ctx.batch.bill_no,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.bill_no) = $event)),
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allBillNo, (bl) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: bl.bill_sequence_no,
                            label: bl.bill_no,
                            value: bl.bill_sequence_no
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bl.bill_no), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseNotice())),
                      type: "button",
                      class: "btn btn-success btn-sm mt-4"
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_19
                    ])
                  ])
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_Datatable, {
                                "table-data": _ctx.tableData,
                                "table-header": _ctx.tableHeader,
                                "enable-items-per-page-dropdown": true
                              }, {
                                "cell-sl": _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(row.sl), 1)
                                ]),
                                "cell-ti": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.ti), 1)
                                ]),
                                "cell-course": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.course), 1)
                                ]),
                                "cell-bn": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.bn), 1)
                                ]),
                                "cell-en": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.en), 1)
                                ]),
                                "cell-an": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.an), 1)
                                ]),
                                "cell-cn": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.cn), 1)
                                ]),
                                "cell-unit_cost": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.unit_cost), 1)
                                ]),
                                "cell-pay_percent": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.pay_percent), 1)
                                ]),
                                "cell-payment_amount": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.payment_amount), 1)
                                ]),
                                "cell-bill_amount": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.bill_amount), 1)
                                ]),
                                "cell-new_unit_cost": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.new_unit_cost), 1)
                                ]),
                                "cell-new_payment_amount": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.new_payment_amount), 1)
                                ]),
                                "cell-new_bill_amount": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.new_bill_amount), 1)
                                ]),
                                "cell-adj_amount": _withCtx(({ row: lists }) => [
                                  _createTextVNode(_toDisplayString(lists.adj_amount), 1)
                                ]),
                                "cell-actions": _withCtx(({ row: lists }) => [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.view(lists)),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#lists_details",
                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                                  }, _hoisted_30, 8, _hoisted_28),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.edit(lists)),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#kt_modal_add_courses",
                                    class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                  }, _hoisted_33, 8, _hoisted_31),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.Delete(lists.id)),
                                    class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                  }, _hoisted_36, 8, _hoisted_34)
                                ]),
                                _: 1
                              }, 8, ["table-data", "table-header"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}